import React from "react";
import UserService from "../services/users";
import WorkorderItemService from "../services/workorderitems";
import UserList from "../components/users/userlist";
import UserEdit from "../components/users/useredit";
import ActionButton from '../components/layout/actionButtons';
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete';
import Search from "../components/general/search";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [], filterItems: [],item: undefined ,holidays:[],docters:[],babies:[]};
  }

  componentDidMount() {
    let deleteButton = <IconButton onClick={()=>{window.confirm("Weet u zeker dat u deze gebruiker wilt verwijderen?") && this.handleDelete(this.state.item)}}><DeleteIcon style={{color:'FFF'}}/></IconButton>

    if (!this.props.match.params.id) {

      this.getItems();

      this.props.handleMenu(
        {
          title: 'Gebruikers',
          handleActions: <ActionButton {...this.props} linkNewItem='/users/0'></ActionButton>
        })

    } else {
      if (this.props.match.params.id === '0') {
        this.setState({ item: {} })
      } else {
        UserService.get(this.props.match.params.id).then(
          (result) => {
            this.setState({ item: result });

            this.props.handleMenu(
              { 
                title: 'Gebruiker ' + this.getName(),
                showBackButton:true,
              handleActions: <ActionButton {...this.props}  handleSave={this.handleSave} itemleft={<React.Fragment>{deleteButton}</React.Fragment>}></ActionButton>
              })

          },
          (err) => {
            this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
            this.props.history.push('/users')
          }
        );

        WorkorderItemService.getHolidayForUser(this.props.match.params.id ).then(
          result => {
          //  console.log("holiday", result);
            this.setState({ holidays: result});
          },
          error => {
            console.log("error", error);
          }
        );

        WorkorderItemService.getDoctersForUser(this.props.match.params.id ).then(
          result => {
          //  console.log("holiday", result);
            this.setState({ docters: result});
          },
          error => {
            console.log("error", error);
          }
        );

        WorkorderItemService.getBabiesForUser(this.props.match.params.id ).then(
          result => {
          //  console.log("holiday", result);
            this.setState({ babies: result});
          },
          error => {
            console.log("error", error);
          }
        );

      }
     
      this.props.handleMenu(
        {
          title: 'Gebruiker' + this.getName(),
          showBackButton:true,
        handleActions: <ActionButton {...this.props}  handleSave={this.handleSave} itemleft={<React.Fragment>{deleteButton}</React.Fragment>}></ActionButton>
        })
    }
  }

  getItems() {
    UserService.get().then(
      result => {
        this.setState({ items: result ,filterItems:result});
      },
      error => {
        console.log("error", error);
      }
    );
    
  }

  handleUpdate = (item) => {
    this.setState({ item: item });
  }

  handleSave = () => {
    let item = this.state.item;
    if (item.firstname && item.lastname && item.email) {
      UserService.save(item).then(
        result => {
          this.props.history.push('/users')
        },
        error => {
          this.props.handleMessage({ title: "Het opslaan is mislukt" });
        }
      );
    } else {
      this.props.handleMessage({ title: "Gegevens zijn niet compleet" });
    }
  }

  handleDelete(item) {
    UserService.delete(item._id).then(
      result => {
        this.props.history.push('/users');
      },
      error => {
        this.props.handleMessage({ title: "Fout bij het verwijderen." });
      }
    );
  }

  handleEdit = (item) =>{
    this.props.history.push('/users/'+item._id);
  }

  handleSearch = (search) => {
    let filterItems = this.state.items;
    filterItems = filterItems.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filterItems })
  }

  compare(a,b) {
    if (a.firstname < b.firstname)
      return -1;
    if (a.firstname > b.firstname)
      return 1;
    return 0;
  }
  
  getName(){

    if(this.state.item){
      return (this.state.item.firstname || "") + " " + (this.state.item.lastname || "");
    }
    return "";
  }
  render() {
 

    return (
      <div>
        {
          this.state.item
            ?
            <UserEdit
              {...this.props}
              item={this.state.item}
              handleUpdate={this.handleUpdate}
              holidays={this.state.holidays}
              docters={this.state.docters}
              babies={this.state.babies}
            />
            :
            <React.Fragment>
                <Search handleSearch={this.handleSearch} />
              <UserList items={this.state.filterItems.sort(this.compare)} handleEdit={this.handleEdit} />
            </React.Fragment>
            
        }
      </div>
    );
  }
}
export default Users;
